import { render, staticRenderFns } from "./Dream.vue?vue&type=template&id=59b906f6&scoped=true&"
import script from "./Dream.vue?vue&type=script&lang=js&"
export * from "./Dream.vue?vue&type=script&lang=js&"
import style0 from "./Dream.vue?vue&type=style&index=0&id=59b906f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b906f6",
  null
  
)

export default component.exports